/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class WindowUtil {
    public static oeffneInTab = (url: string) => {
        // https://stackoverflow.com/questions/45046030/maintaining-href-open-in-new-tab-with-an-onclick-handler-in-react
        const tab = window.open(url, '_blank', 'noopener,noreferrer');
        if (tab) {
            tab.opener = null;
        }
    }
}